PegasusTemplate.ToolbarController = Ember.ObjectController.extend({
  actions: {
    hideControls: function(){
      PegasusTemplate.stateMachine.send('hideControls');
    },

    alignCloseLeft: function(){
      this.set('selectedCloseAlignment', 'left');
    },

    alignCloseRight: function(){
      this.set('selectedCloseAlignment', 'right');
    },

    alignLeft: function(){
      this.set('dataAlignment', 'left');
    },

    alignCenter: function(){
      this.set('dataAlignment', 'center');
    },

    alignRight: function(){
      this.set('dataAlignment', 'right');
    },

    didCandyToggle: function(data, context) {
      if ( data === 'shadow' ) {
        var newValue = this.get('isShowingShadow') ? false : true;
        this.set('isShowingShadow', newValue);
      }
    },

    selectCloseStyle: function(style) {
      this.set('selectedCloseButton', style);
    },

    selectBorderRadius: function(option) {
      this.set('selectedBorderRadiusOption', option);
    }
  },

  mediaQueries: '',

  processQueriesObserver: function(){
    if ( this.get('controllers.template.intrinsicTemplateWidth') && this.get('selectedTemplateWidth') ) {
      Em.run.scheduleOnce('sync', this, 'transplantQueries');
    }
  }.observes('controllers.template.intrinsicTemplateWidth', 'selectedTemplateWidth'),

  transplantQueries: function() {
    var styles = $('<style type="text/css">');

    var selectedWidth = this.get('selectedTemplateWidth');
    var queryTarget;
    var intrinsicTemplateWidth = this.get('controllers.template.intrinsicTemplateWidth');

    if ( ! selectedWidth ) {
      return;
    }

    function generateQuery(block){
      return block.get('media_queries').reduce(function(accum, item){
        queryTarget = item.inflection_point;

        accum[queryTarget] = accum[queryTarget] || [];
        accum[queryTarget].push( {
          className: item.class_name,
          style: item.style,
          propertyName: item.property_name
        } );

        return accum;
      }, {});
    }

    PegasusTemplate.lookupStore().all(PegasusTemplate.Block).toArray().forEach(function(row){
      var name = row.get('name');
      var queries = [];
      if ( row.get('media_queries') ){
        queries.push( generateQuery( row ) );
      }
      queries.forEach(function(q){
        var opening = '{',
          closing = '}',
          selector;

        Object.keys( q ).sort().reverse().forEach(function(inflection){
          var rules = q[inflection],
            queryRule = '',
            selectorParts,
            isQuotedClass,
            quoteEnd;

          rules.forEach(function(rule){
            isQuotedClass = rule.className.indexOf('"') === 0;

            if ( isQuotedClass ) {
              quoteEnd = rule.className.lastIndexOf('"') + 1;

              selectorParts = [
                rule.className.slice(1, quoteEnd-1),
                rule.className.slice(quoteEnd)
              ];
            } else {
              selectorParts = rule.className.split(' ');
            }

            selector = '[name="'+name+'"] .'+ selectorParts[0].split(' ').join('.') + ' ' + selectorParts.slice(1).join(' ');
            queryRule = queryRule + "@media only screen and (" + rule.propertyName +':'+ inflection +') {' + selector + ' {';
            queryRule = queryRule + rule.style + closing + closing;
          });

          styles.html( styles.html() + queryRule );
        });
      });
    });

    this.set('mediaQueries', styles.html());
  },

  dataVrStructurePaddingTopBinding: 'designBoundView.row.topPaddingCell.dataVrStructurePaddingTop',
  dataVrStructurePaddingBottomBinding: 'designBoundView.row.bottomPaddingCell.dataVrStructurePaddingBottom',

  panelMode: 'Blocks',

  selectedBorderRadiusOption: 'none',

  borderRadiusChanged: function(){
    var params = {};

    var option = this.get('selectedBorderRadiusOption');

    switch(option) {
      case 'tiny':
        params.selectedBorderRadius = 1;
        break;
      case 'small':
        params.selectedBorderRadius = 6;
        break;
      case 'medium':
        params.selectedBorderRadius = 12;
        break;
      case 'large':
        params.selectedBorderRadius = 24;
        break;
      default:
        params.selectedBorderRadius = 0;
    }

    this.setProperties(params);
  }.observes('selectedBorderRadiusOption'),

  isBorderRadiusNone: function(){
    return this.get('selectedBorderRadiusOption') === 'none';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusTiny: function(){
    return this.get('selectedBorderRadiusOption') === 'tiny';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusSmall: function(){
    return this.get('selectedBorderRadiusOption') === 'small';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusMedium: function(){
    return this.get('selectedBorderRadiusOption') === 'medium';
  }.property('selectedBorderRadiusOption'),

  isBorderRadiusLarge: function(){
    return this.get('selectedBorderRadiusOption') === 'large';
  }.property('selectedBorderRadiusOption'),

  isCloseStyleCircleXGray: function(){
    return this.get('selectedCloseButton') === 'circle_x_gray.png';
  }.property('selectedCloseButton'),

  isCloseStyleXGray: function(){
    return this.get('selectedCloseButton') === 'x_gray.png';
  }.property('selectedCloseButton'),

  isCloseStyleXWhite: function(){
    return this.get('selectedCloseButton') === 'x_white.png';
  }.property('selectedCloseButton'),

  isShowingShadow: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      if ( value ) {
        this.setProperties({
          selectedShadowBlurRadius: 38,
          selectedShadowSpreadRadius: -17
        });
      } else {
        this.setProperties({
          selectedShadowBlurRadius: 0,
          selectedShadowSpreadRadius: -12
        });
      }
      return value;
    }

    return null;
  }.property(),

  selectedCloseAlignment: 'right',

  selectedCloseButton: 'circle_x_gray.png',

  selectedBlockRegionImageAttachment: 'fixed',

  selectedTemplateAppearance: 'centered',

  successActionId: '1',

  successActionRedirectURL: '',

  isRedirectSelected: function(){
    return this.get('successActionId') === '2';
  }.property('successActionId'),

  needs: ['editing', 'socialFollow', 'application', 'modal', 'template'],

  selectableContactLists: [],

  showForwardEmailOption: false,

  next: function(){
    this.set('isSaving', true);
    this.send('saveAndContinue');
  },

  exit: function(){
    this.set('isSaving', true);
    this.send('saveAndExit');
  },

  userSelectedColors: function(_,value){
    if ( typeof(value) !== 'undefined' ) {
      $(window).trigger('recentColorsChanged', [ value ]);
      return value;
    }

    return [];
  }.property(),

  userSelectedColorsChanged: function(){
  }.observes('userSelectedColors.length'),

  errors: {},

  blockViewMode: null,

  toolbarDescription: '',

  touched: false,

  isAuthorizedToRemoveLogo: false,

  subTabMode: '',
  subTabOneDisplay: '',
  subTabOneMode: '',
  subTabTwoDisplay: '',
  subTabTwoMode: '',

  clearSubTab: function(){
    this.setProperties({
      subTabMode: '',
      subTabOneDisplay: '',
      subTabOneMode: '',
      subTabTwoDisplay: '',
      subTabTwoMode: '',
      toolbarDescription: ''
    });
  },

  content: function(){
    return this.get('controllers.editing.content') || {};
  }.property('controllers.editing.content'),

  edited: function(){
    return this.get('controllers.editing.edited');
  }.property('controllers.editing.edited'),

  designBoundView: function(){
    return this.get('edited');
  }.property('edited'),

  editImage: function(){
    PegasusTemplate.stateMachine.send('editImage');
  },

  editText: function(){
    PegasusTemplate.stateMachine.send('editText');
  },

  saveNewList: function(){
    this.send('saveNewContactList', this.get('designBoundView.newListName') );
  },

  saveAndPreview: function(){
    PegasusTemplate.stateMachine.transitionTo('validating.previewing');
  },

  sendTest: function(){
    var blockedFromSendingEmail = PegasusTemplate.get('blockedFromSendEmail');

    if (blockedFromSendingEmail) {
      this.informUserOfBlock();
    }
    else {
      PegasusTemplate.stateMachine.transitionTo('validating.testing');
    }
  }
});

(function(){
  var currentWidth = null, currentHeight = '99';

  PegasusTemplate.ToolbarController.reopen({
    electedTemplateWidth: function(_,value) {
      if ( typeof(value) !== 'undefined' ) {
        var command = PegasusTemplate.ChangeTemplateWidthCommand.create({
          executeWidth: value,
          unexecuteWidth: this.get('selectedTemplateWidth')
        });

        command.execute();
        return value;
      }
      return null;
    }.property(),
    selectedTemplateWidth: function(_,value) {
      if ( typeof(value) !== 'undefined') {
        if ( !PegasusTemplate.loadedTemplate() ) {
          return value;
        }
        if ( value >= PegasusTemplate.loadedTemplate().get('minContentWidth') ) {
          currentWidth = value;
        }
      }

      return currentWidth;
    }.property(),

    selectedTemplateHeight: function(_,value) {
      if ( typeof(value) !== 'undefined') {
        if ( !PegasusTemplate.loadedTemplate() ) {
          return value;
        }
        if ( value >= PegasusTemplate.loadedTemplate().get('minContentHeight') ) {
          currentHeight = value;
        }
      }
      return currentHeight;
    }.property()
  });
})();

PegasusTemplate.ToolbarController.reopen({
  initialThemeName: null,
  initialEmailDecorationValues: null,

  defaultBackgroundImage: null,
  defaultBackgroundColor: null,
  defaultFontFace: null,
  defaultThemeColor: null,
  selectedBorderWidth: null,
  selectedBorderColor: null,
  selectedBorderRadius: null,
  selectedIsAnimatedGif: null,
  selectedShadowBlurRadius: null,
  selectedShadowSpreadRadius: null,


  isViewOnlineEnabled: true,
  viewOnlineLabel: Em.I18n.t("instructions.view_email_in_browser"),
  viewOnlineLabelColor: '#c1c1c1',
  viewOnlineLabelSize: '16',
  viewOnlineLabelAlignment: 'right',
  viewOnlineLabelBold: '',
  viewOnlineLabelItalic: '',

  userLevelLogoHidden: null,
  initialLogoState: null,
  didToggleFooterLogo: false,
  isFooterEmailPreferencesEnabled: true,
  isFooterLogoEnabled: function(_,value){
    if ( typeof(value) !== 'undefined') {
      if ( this.get('initialLogoState') === null ) {
        this.set('initialLogoState', value);
      } else if( this.get('initialLogoState') !== value ) {
        this.set('didToggleFooterLogo', true);
      } else {
        this.set('didToggleFooterLogo', false);
      }
      return value;
    }
    return 'true';
  }.property(),
  desiredFooterLabelColor: '',
  desiredFooterAnchorColor: '',
  footerLabelOpen: '',
  footerLabelJoin: '',
  footerLabelClose: '',
  footerLabelColor: '',
  footerAnchorColor: '',
  footerLabelSize: '12',
  footerLabelAlignment: 'center',
  footerLabelBold: '',
  footerLabelItalic: '',
  footerCompany: '',
  footerStreetAddress: '',
  footerExtendedAddress: '',
  footerLocality: '',
  footerRegion: '',
  footerPostalCode: '',
  footerPhone: '',
  footerCountry: '',

  ogpTitle: '',
  ogpDescription: '',
  ogpImage: '',

  previousSelectedTheme: null,

  selectedPrimaryColor: null,
  selectedSecondaryColor: null,

  selectedTheme: null,

  resetFontFace: function(){
    this.set('selectedFontFace', Em.get(PegasusTemplate, 'defaults').defaultFontFace);
  },
  resetThemeColor: function(){
    this.set('selectedRowColor', Em.get(PegasusTemplate, 'defaults').defaultThemeColor);
    this.didChangeSelectedRowColor();
  },

  uploadCustomBlockRegionBackground: function(){
    var type = PegasusTemplate.loadedTemplate().get('blockRegionImageType');
    var payload = Em.View.extend(PegasusTemplate.ImageAttributesMixin, {
      container: this.container,
      type: type,
      dataSrc: this.get('selectedBlockRegionImage'),
      backgroundStyle: this.get('selectedBlockRegionImageStyle')
    }).create();

    var row = Em.View.create({
      container: this.container,
      blocks: [],
      mutateForOut: Em.K
    });

    var image = PegasusTemplate.ImageShowView.create({
      container: this.container,
      row: row
    });

    image.set('payload', payload);

    PegasusTemplate.stateMachine.transitionTo('editing.' + type.camelize(), image);
  },

  uploadCustomBackground: function(){
    var type = PegasusTemplate.loadedTemplate().get('bodyImageType');
    var payload = Em.View.extend(PegasusTemplate.ImageAttributesMixin, {
      container: this.container,
      type: type,
      dataSrc: this.get('selectedBackgroundImage'),
      backgroundStyle: this.get('selectedBackgroundImageStyle')
    }).create();

    var row = Em.View.create({
      container: this.container,
      blocks: [],
      mutateForOut: Em.K
    });

    var image = PegasusTemplate.ImageShowView.create({
      container: this.container,
      row: row
    });

    image.set('payload', payload);

    PegasusTemplate.stateMachine.transitionTo('editing.' + type.camelize(), image);
  },
  selectedFontFace: null,
  selectedBackgroundColor: null,
  selectedBackgroundImageStyle: function(_, value){
    if ( typeof(value) !== 'undefined' ) {
      if ( value === 'Cover' ) {
        this.set('selectedBackgroundImageCovers', true);
      } else {
        this.set('selectedBackgroundImageCovers', false);
      }
    }

    if ( this.get('selectedBackgroundImageCovers') ) {
      return 'Cover';
    }

    return 'Pattern';
  }.property(),
  selectedBackgroundImageCovers: function(_, value) {
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }
    return null;
  }.property(),

  selectedBackgroundImage: function(_, value) {
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }
    return null;
  }.property(),

  selectedBlockRegionColor: null,
  selectedBlockRegionImageStyle: function(_, value){
    if ( typeof(value) !== 'undefined' ) {
      if ( value === 'Cover' ) {
        this.set('selectedBlockRegionImageCovers', true);
      } else {
        this.set('selectedBlockRegionImageCovers', false);
      }
    }

    if ( this.get('selectedBlockRegionImageCovers') ) {
      return 'Cover';
    }

    return 'Pattern';
  }.property(),
  selectedBlockRegionImageCovers: function(_, value) {
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }
    return null;
  }.property(),


  selectedBlockRegionImage: function(_, value) {
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }
    return null;
  }.property(),

  selectedBlockRegionImageAnimated: function(_, value) {
    if ( typeof(value) !== 'undefined' ) {
      return value;
    }
    return null;
  }.property(),

  selectedTemplateAutoHeight: function(_,value) {
    window.clearInterval( window.sizeInterval );
    window.clearTimeout( window.sendRenderingOptionsTimer );

    if ( typeof(value) !== 'undefined' ) {
      if ( value === 'true' ) {
        var self = this;

        window.sizeInterval = window.setInterval( function(){
          window.clearTimeout( window.sendRenderingOptionsTimer );

          window.sendRenderingOptionsTimer = Em.run.next(function(){
            var height = $('.center-wrapper').height();
            if ( height ) {
              self.set('selectedTemplateHeight', height);
              Em.run.scheduleOnce('afterRender', PegasusTemplate.lookupController('frameCommManager'), 'sendTemplateRenderingOptions');
            }
          });

        }, 150 );
      }

      return value;
    }

    return 'true';
  }.property(),

  selectedRowColor: function(_, value) {
    var defaults = Em.get(PegasusTemplate, 'defaults');
    if ( typeof(value) !== 'undefined' ) {
      this.set('previousSelectedRowColor', this.get('selectedRowColor') );
      return value;
    }
    return defaults ? defaults.selectedRowColor : '';
  }.property('PegasusTemplate.defaults'),
  previousSelectedRowColor: null,
  resetStyles: function(){
    Em.run.scheduleOnce('afterRender', this, function(){
      this.resetFontFace();
      this.resetThemeColor();
    });
  },

  applyTheme: function(t){
    var theme = t || this.get('selectedTheme');

    this.setProperties({
      selectedBorderWidth: theme.get('border_thickness'),
      selectedBorderRadius: theme.get('border_radius'),
      selectedBorderColor: theme.get('border_color'),
      selectedShadowSpreadRadius: theme.get('shadow_width'),
      selectedShadowBlurRadius: theme.get('shadow_blur'),
      selectedPrimaryColor: theme.get('primary_color'),
      selectedSecondaryColor: theme.get('secondary_color'),
      selectedBackgroundImage: theme.get('body_background_image'),
      selectedBackgroundColor: theme.get('body_background_color'),
      selectedFontFace: theme.get('body_font_family'),
      selectedRowColor: theme.get('row_color'),
      initialEmailDecorationValues: {
        selectedBorderWidth: theme.get('border_thickness'),
        selectedBorderRadius: theme.get('border_radius'),
        selectedBorderColor: theme.get('border_color'),
        selectedShadowSpreadRadius: theme.get('shadow_width'),
        selectedShadowBlurRadius: theme.get('shadow_blur'),
      }
    });

    Object.keys(theme.get('css')).forEach(function(key){
      $('.center .'+key).css(theme.get('css.' + key));
    });

    Em.run.scheduleOnce('afterRender', this, function(){
      $('.center-wrapper').css('font-family', this.get('selectedFontFace') );
    });

    $(window).trigger('themeChanged');
  },

  didReplaceColors: function(map){
    var parent = PegasusTemplate.loadedTemplate().contentRoot(),
      klass = PegasusTemplate.loadedTemplate().get('globalManipulationClass'),
      childPosition = 0,
      child = parent.objectAt(childPosition),
      source = child.mutateForOut(null, false).editor_cookie,
      element;

      Object.keys(map).forEach(function(key){
        rgb = PegasusTemplate.Helpers.convertHexToRgb(key);
        matcher = new RegExp(key, 'gi');
        rgbMatcher = new RegExp("rgb\\s*\\(\\s*"+rgb[0]+"\\s*,\\s*"+rgb[1]+"\\s*,\\s*"+rgb[2]+"\\s*\\)", 'gi');
        source = source.replace(matcher, map[key]);
        source = source.replace(rgbMatcher, map[key]);
      });

      element = klass.create({
        container: parent.container,
        sourceElement: source
      }),

    parent.removeObject( child );
    parent.insertAt( childPosition, element );
  },

  makeBackgroundColorHistory: function(newColor, oldColor){
    var image = this.get('selectedBackgroundImage');
    var executeColor = newColor,
      unexecuteColor = oldColor;

    var command = PegasusTemplate.EditBodyImageCommand.create({
      executeColor: executeColor,
      unexecuteColor: unexecuteColor,
      executeImage: image,
      unexecuteImage:image,
      executeStyle: this.get('selectedBackgroundImageCovers'),
      unexecuteStyle: this.get('selectedBackgroundImageCovers')
    });

    command.execute();
  },

  makeBackgroundImageHistory: function(image, style){
    var color = this.get('selectedBackgroundColor');

    var command = PegasusTemplate.EditBodyImageCommand.create({
      executeColor: color,
      unexecuteColor: color,
      executeImage: image,
      unexecuteImage: this.get('selectedBackgroundImage'),
      executeStyle: style,
      unexecuteStyle: this.get('selectedBackgroundImageCovers')
    });

    command.execute();
  },

  didChangeSelectedFontFace: function(){
    Em.run.scheduleOnce('afterRender', this, function(){
      $('.center-wrapper').css('font-family', this.get('selectedFontFace') );
    });
  }.observes('selectedFontFace'),

  didChangePrimaryColor: function(color) {
    $(window).trigger('primaryColorChanged');
  },

  didChangeThemeDecoration: function(props){
    var overrides = props || {};
    var callback = function(){
      var command = PegasusTemplate.ChangeThemeDecorationCommand.create({
        unexecuteProperties: unexecuteProperties,
        executeProperties: executeProperties
      });

      command.execute();
    };

    var executeProperties = $.extend({
      selectedBorderColor: this.get('selectedBorderColor'),
      selectedBorderRadius: this.get('selectedBorderRadius'),
      selectedBorderWidth: this.get('selectedBorderWidth'),
      selectedShadowBlurRadius: this.get('selectedShadowBlurRadius'),
      selectedShadowSpreadRadius: this.get('selectedShadowSpreadRadius')
    }, overrides);

    var unexecuteProperties = this.get('initialEmailDecorationValues');
    PegasusTemplate.get('CommandManager.instance').blockInteraction(callback.bind(this));
  },

  didChangeSecondaryColor: function(color) {
    $(window).trigger('secondaryColorChanged');
  },

  didChangeSelectedRowColor: function(){
    $(window).trigger('themeRowColorChanged');
  },

  makeThemeRowColorHistory: function(newColor, oldColor){
    var callback = function(){
      var parent = PegasusTemplate.loadedTemplate().contentRoot(),
        command = PegasusTemplate.ChangeThemeRowColorCommand.create({
          unexecuteColor: oldColor,
          executeColor: newColor
        });

      $(window).trigger('themeRowColorChanged');

      PegasusTemplate.stateMachine.send('didSaveFragment');

      Em.run.scheduleOnce('afterRender', this, function(){
        var newHTML = PegasusTemplate.loadedTemplate().backup();
        command.set('sourceElement', newHTML);
        command.execute();
      });
    };

    PegasusTemplate.get('CommandManager.instance').blockInteraction(callback.bind(this));
  }
});

PegasusTemplate.ToolbarController.reopen({
  desiredHeaderColor: null,
  desiredParagraphColor: null,
  desiredRowColor: null,

  clearRows: function(){
    var command = PegasusTemplate.ClearRowsCommand.create();

    PegasusTemplate.stateMachine.send('didSaveFragment');

    command.makeBackup();

    Em.beginPropertyChanges();
    PegasusTemplate.blockRegionInstance.clear();
    Em.endPropertyChanges();

    Em.run.scheduleOnce('afterRender', this, function(){
      command.set('sourceElement', PegasusTemplate.loadedTemplate().generateOutput(false).editor_cookie);
      command.execute();
    });
  }

});

(function(){
  var host = window.location.protocol + '//' + window.location.host;
  var key = '?' + Math.random()*10000000000000000;

  PegasusTemplate.ToolbarController.reopen({
    followIconStyles: [
      {
        group: 'circle',
        sampleImageGroup: 'circle-samples',
        facebookUrl: host + '/pegasus_template/assets/circle-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/circle-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/circle-youtube.png' + key
      },
      {
        group: 'square',
        sampleImageGroup: 'square-samples',
        facebookUrl: host + '/pegasus_template/assets/square-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/square-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/square-youtube.png' + key
      },
      {
        group: 'hexagon',
        sampleImageGroup: 'hexagon-samples',
        facebookUrl: host + '/pegasus_template/assets/hexagon-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/hexagon-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/hexagon-youtube.png' + key
      },
      {
        group: 'circleline',
        sampleImageGroup: 'circleline-samples',
        facebookUrl: host + '/pegasus_template/assets/circleline-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/circleline-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/circleline-youtube.png' + key
      },
      {
        group: 'hexline',
        sampleImageGroup: 'hexline-samples',
        facebookUrl: host + '/pegasus_template/assets/hexline-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/hexline-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/hexline-youtube.png' + key
      },
      {
        group: 'graycircle',
        sampleImageGroup: 'graycircle-samples',
        facebookUrl: host + '/pegasus_template/assets/graycircle-facebook.png' + key,
        twitterUrl: host + '/pegasus_template/assets/graycircle-twitter.png' + key,
        youtubeUrl: host + '/pegasus_template/assets/graycircle-youtube.png' + key
      }
    ],

    replaceImage: function(handler){
      PegasusTemplate.lookupController('frameCommManager').replaceImage(handler);
    },

    isAlignCloseLeft: function(){
      return this.get('selectedCloseAlignment') === 'left';
    }.property('selectedCloseAlignment'),

    isAlignCloseRight: function(){
      return this.get('selectedCloseAlignment') === 'right';
    }.property('selectedCloseAlignment'),

    isAlignLeft: function(){
      return this.get('dataAlignment') === 'left';
    }.property('dataAlignment'),

    isAlignRight: function(){
      return this.get('dataAlignment') === 'right';
    }.property('dataAlignment'),

    isAlignCenter: function(){
      return !this.get('isAlignLeft') && !this.get('isAlignRight');
    }.property('isAlignLeft', 'isAlignRight'),

    width: function(){
      // returning the width here would be create a responsiveness problem
      return '100%';
    }.property('dataWidth')
  });
})();

PegasusTemplate.ToolbarController.reopen({
  activeField: null,
  removeNetwork: function(){
    this.swapViews(null);
  },
  swapViews: function(viewB){
    var a, b,
      parent = this.get('edited.payload.networks'),
      active = parent.filterProperty( 'type', this.get('activeField.type') ).objectAt(0),
      bIndex,
      aIndex,
      aIsEmpty,
      bIsEmpty;

    function finalize(){
      parent.set('parentView.dataNetworkOrder', parent.filterProperty('type').map( function(child){
        return child.get('type');
      }).join(',') );
      this.set('activeField', null);
      parent.rerender();
    }

    a = active;

    aIsEmpty = !a || a.get('type') === 'empty';

    if( !viewB && !aIsEmpty ){
      parent.removeObject(a);
      a.remove();
      finalize.call(this);
      return;
    }

    bIsEmpty = !parent.filterProperty( 'type', viewB.get('type') ).objectAt(0);

    if( aIsEmpty && bIsEmpty ){
      aIndex = parent.get('length');
      parent.insertAt( aIndex, viewB );
      finalize.call(this);
      return;
    }

    if( aIsEmpty ){
      parent.removeObject( viewB );
      parent.pushObject( viewB );
      finalize.call(this);
      return;
    }

    if( bIsEmpty ){
      aIndex = parent.indexOf( a );
      parent.removeObject( a );
      parent.insertAt( aIndex, viewB );
      finalize.call(this);
      return;
    }

    b = parent.filterProperty( 'type', viewB.get('type') ).objectAt(0);
    aIndex = parent.indexOf( a );
    bIndex = parent.indexOf( b );
    parent.removeObject( b );
    parent.insertAt( aIndex, b );
    parent.removeObject( a );
    parent.insertAt( bIndex, a );
    finalize.call(this);
  }
});
